import React from 'react';
import Navigation from 'Components/Navigation';
import { withRouter } from 'Components/withRouter';
import { withAuthenticatedUser } from 'Components/withAuthenticatedUser';

class WelcomePage extends React.Component {

    render() {

        var name = this.props.authenticatedUser && this.props.authenticatedUser.name;

        return (
            <div>
                <Navigation authenticatedUser={this.props.authenticatedUser} />
                <div className="padding-tb10" />
                <div className="container-fluid padding-lr55">
                    <div className="row">
                        <div className="col-lg-12">
                            <p>Welcome { name }</p>
                            <p>
                                You are logged into the Deadline Couriers website.
                                Please select from the options above. If no options are available please contact your administrator.
                            </p>
                        </div>
                    </div>
                </div>
            </div>
            );
    }
}

const AuthenticatedWelcomePage = withAuthenticatedUser(withRouter(WelcomePage));

export default AuthenticatedWelcomePage;
